import { JsonConverter, JsonCustomConvert } from 'json2typescript';
import * as utils from '../core.utils';

@JsonConverter
export class DateConverter implements JsonCustomConvert<Date> {
    serialize(date: Date): any {
        return date.toISOString();
    }
    deserialize(date: any): Date {
        if (!date) {
            return null;
        }

        return utils.parseDate(date);
    }
}